import * as React from 'react';
import { formControlClasses, formLabelClasses, inputBaseClasses, inputLabelClasses, SxProps, TextField, Theme } from '@mui/material';
import { useSafeId } from '../../hooks';

const styles: Record<string, SxProps<Theme>> = {
  staticTextFieldRoot: {
    [`& .${inputBaseClasses['input']}.${inputBaseClasses['disabled']}`]: {
      color: 'text.primary',
      fontWeight: 'fontWeightMedium',
      fontSize: 'body1.fontSize',
      '-webkit-text-fill-color': 'initial'
    },
    [`& .${formLabelClasses['root']}.${inputLabelClasses['root']}`]: {
      color: 'text.secondary',
      fontWeight: 'fontWeightMedium',
      fontSize: 'overline.fontSize'
    },
    [`&.${formControlClasses['marginDense']} >label`]: {
      transform: 'translate(12px, 25px) scale(0.85)'
    },
    maxHeight: '3rem',
    [`& >div.${inputBaseClasses['root']}`]: {
      maxHeight: '3rem',
      margin: 0
    }
  }
};

type MarginType = 'dense' | 'normal' | 'none';

export interface StaticTextFieldProps {
  value?: string;
  fullWidth?: boolean;
  label?: string;
  margin?: MarginType;
  classes?: any;
  id?: string;
  sx?: SxProps<Theme>;
}

const StaticTextField: React.FunctionComponent<StaticTextFieldProps> = ({
  label,
  margin,
  fullWidth,
  value,
  classes,
  id,
  sx
}: StaticTextFieldProps) => {
  const { staticTextFieldRoot } = styles;
  const safeId = useSafeId(id);
  return (
    <TextField
      sx={[staticTextFieldRoot, sx] as SxProps<Theme>}
      variant="standard"
      label={label}
      margin={margin}
      fullWidth={fullWidth}
      classes={classes}
      value={value}
      aria-label={label}
      InputProps={{ disableUnderline: true }}
      disabled
      id={safeId}
    />
  );
};

StaticTextField.defaultProps = {
  margin: 'normal',
  fullWidth: true,
  label: ''
};

StaticTextField.displayName = 'StaticTextField';

export { StaticTextField };
